<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>add</mat-icon>
      Add Related Content
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Related Content Listing ID</mat-label>
      <input formControlName="related_listing_id" matInput required />
    </mat-form-field>
  </section>

  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid || loading"
      mat-button
      matTooltip="Save product info."
      type="submit"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
